module.exports = __webpack_public_path__ + "static/character--keoni-bill@3x.e2e8d9f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--keoni-bill@3x.png
// module id = 1274
// module chunks = 35783957827783